/* tslint:disable */
/* eslint-disable */
/**
 * CementService API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const RHIMCementServiceDataPointCloudScansExtractionState = {
    InProgress: 'InProgress',
    Failed: 'Failed',
    Completed: 'Completed',
} as const;

export type RHIMCementServiceDataPointCloudScansExtractionState = typeof RHIMCementServiceDataPointCloudScansExtractionState[keyof typeof RHIMCementServiceDataPointCloudScansExtractionState];


export interface RHIMCementServiceDataPointCloudScansMatrix4x4 {
    'm11': number;
    'm12': number;
    'm13': number;
    'm14': number;
    'm21': number;
    'm22': number;
    'm23': number;
    'm24': number;
    'm31': number;
    'm32': number;
    'm33': number;
    'm34': number;
    'm41': number;
    'm42': number;
    'm43': number;
    'm44': number;
}

export const RHIMCementServiceDataPointCloudScansPanoramaImagesState = {
    InProgress: 'InProgress',
    ProcessingFailed: 'ProcessingFailed',
    Completed: 'Completed',
} as const;

export type RHIMCementServiceDataPointCloudScansPanoramaImagesState = typeof RHIMCementServiceDataPointCloudScansPanoramaImagesState[keyof typeof RHIMCementServiceDataPointCloudScansPanoramaImagesState];


export interface RHIMCementServiceDataPointCloudScansPoint3D {
    'x': number;
    'y': number;
    'z': number;
}

export const RHIMCementServiceDataPointCloudScansRefractoryCondition = {
    NewLining: 'NewLining',
    PartiallyNewLining: 'PartiallyNewLining',
    WornRefractories: 'WornRefractories',
    CleanShell: 'CleanShell',
} as const;

export type RHIMCementServiceDataPointCloudScansRefractoryCondition = typeof RHIMCementServiceDataPointCloudScansRefractoryCondition[keyof typeof RHIMCementServiceDataPointCloudScansRefractoryCondition];



export const RHIMCementServiceDataPointCloudScansScanResolution = {
    Full: 'Full',
    Reduced: 'Reduced',
} as const;

export type RHIMCementServiceDataPointCloudScansScanResolution = typeof RHIMCementServiceDataPointCloudScansScanResolution[keyof typeof RHIMCementServiceDataPointCloudScansScanResolution];



export const RHIMCementServiceDataPointCloudScansScanState = {
    InProgress: 'InProgress',
    InitialProcessingFailed: 'InitialProcessingFailed',
    Completed: 'Completed',
} as const;

export type RHIMCementServiceDataPointCloudScansScanState = typeof RHIMCementServiceDataPointCloudScansScanState[keyof typeof RHIMCementServiceDataPointCloudScansScanState];



export const RHIMCementServiceV1ControllersPanoramaImageQuality = {
    Low: 'Low',
    Medium: 'Medium',
    High: 'High',
} as const;

export type RHIMCementServiceV1ControllersPanoramaImageQuality = typeof RHIMCementServiceV1ControllersPanoramaImageQuality[keyof typeof RHIMCementServiceV1ControllersPanoramaImageQuality];


export interface RHIMCementServiceV1ModelsCampaignDto {
    /**
     * A unique (per vessel) number that represents the campaign
     */
    'id': number;
    /**
     * The text to be displayed for a campaign.
     */
    'displayText': string;
    /**
     * This campaigns starts at this moment in time and ends when a new campaign starts.
     */
    'startTimestamp': string;
}
export interface RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto {
    /**
     * A unique (per vessel) number that represents the campaign
     */
    'id': number;
    /**
     * The text to be displayed for a campaign.
     */
    'displayText': string;
    /**
     * This campaigns starts at this moment in time and ends when a new campaign starts.
     */
    'startTimestamp': string;
}

export const RHIMCementServiceV1ModelsDownloadFileState = {
    NotAvailable: 'NotAvailable',
    PendingZipFileCreation: 'PendingZipFileCreation',
    ZipFileCreationInProgress: 'ZipFileCreationInProgress',
    ReadyForDownload: 'ReadyForDownload',
} as const;

export type RHIMCementServiceV1ModelsDownloadFileState = typeof RHIMCementServiceV1ModelsDownloadFileState[keyof typeof RHIMCementServiceV1ModelsDownloadFileState];


export interface RHIMCementServiceV1ModelsDrillingMeasurementDto {
    'rm': number;
    'angle': number;
    'remainingThickness': number;
}
export interface RHIMCementServiceV1ModelsDustZoneDto {
    'rmFrom': number;
    'rmTo': number;
    'angleFrom': number;
    'angleTo': number;
}
export interface RHIMCementServiceV1ModelsExtractionDto {
    'id': string;
    'extractionDate': string;
    'extractionState': RHIMCementServiceDataPointCloudScansExtractionState;
    'errorMessage'?: string | null;
    'logOutput'?: string | null;
    'version': string;
    'comment'?: string | null;
    'isPublished': boolean;
    'dustZones': Array<RHIMCementServiceV1ModelsDustZoneDto>;
    'remainingThicknessSliderRange'?: RHIMCementServiceV1ModelsSliderRangeDto | null;
    'drillingMeasurements': Array<RHIMCementServiceV1ModelsDrillingMeasurementDto>;
    'kilnAxisTransformationMatrix'?: RHIMCementServiceDataPointCloudScansMatrix4x4 | null;
    'minRemainingThickness': Array<number>;
    'q05RemainingThickness': Array<number>;
    'medianRemainingThickness': Array<number>;
    'q95RemainingThickness': Array<number>;
    /**
     * @deprecated
     */
    'maxRemainingThickness': Array<number>;
    'remainingThicknessTable': Array<Array<number>>;
}


export interface RHIMCementServiceV1ModelsExtractionOverviewDto {
    'id': string;
    'extractionDate': string;
    'extractionState': RHIMCementServiceDataPointCloudScansExtractionState;
    'version': string;
    'comment'?: string | null;
    'isPublished': boolean;
    'dustZonesCount': number;
}


export interface RHIMCementServiceV1ModelsKilnShellTemperatureProfileDto {
    /**
     * The length of the kiln in meters
     */
    'kilnLength': number;
    /**
     * An array of minimum temperatures.  Each profile segment starts at RM = index * KilnLength / lengthOfArray  and ends at RM = (index + 1) * KilnLength / lengthOfArray  the center point is at RM = (index + 0.5) * KilnLength / lengthOfArray
     */
    'minTemperatures': Array<number>;
    /**
     * An array of maximum temperatures.  Each profile segment starts at RM = index * KilnLength / lengthOfArray  and ends at RM = (index + 1) * KilnLength / lengthOfArray  the center point is at RM = (index + 0.5) * KilnLength / lengthOfArray
     */
    'maxTemperatures': Array<number>;
    /**
     * An array of mean temperatures.  Each profile segment starts at RM = index * KilnLength / lengthOfArray  and ends at RM = (index + 1) * KilnLength / lengthOfArray  the center point is at RM = (index + 0.5) * KilnLength / lengthOfArray
     */
    'meanTemperatures': Array<number>;
    /**
     * The timestamp of this profile.  If this dto is a summary over a campaign or all campaigns the timestamp is null
     */
    'timestamp'?: string | null;
    /**
     * The Campaign to which this profile belongs.  If campaign is null this is a summary over all profiles of a vessel
     */
    'campaign'?: number | null;
}
export interface RHIMCementServiceV1ModelsKilnStoppageDto {
    'id': string;
    'beginTimestamp': string;
    'endTimestamp': string;
    'category'?: string | null;
    'reason'?: string | null;
    'description'?: string | null;
}
export interface RHIMCementServiceV1ModelsLinkedScanInformation {
    'drillingMeasurementCount': number;
    'liningId'?: string | null;
    'hasValidKilnGeometry': boolean;
}
export interface RHIMCementServiceV1ModelsProcessDataDto {
    'timestamp': string;
    'processDataValues': { [key: string]: number; };
}
export interface RHIMCementServiceV1ModelsPublishExtractioDto {
    'extractionId'?: string | null;
}
export interface RHIMCementServiceV1ModelsQualityDataDto {
    'timestamp': string;
    'qualityDataValues': { [key: string]: { [key: string]: number; }; };
}
export interface RHIMCementServiceV1ModelsReportConfigDto {
    'liningThicknessThresholds': Array<number>;
    'crossSectionsInterval': number;
    'crossSectionsSpecialPositions': Array<number>;
}
export interface RHIMCementServiceV1ModelsScanDetailedOverviewDto {
    'id': string;
    'scanDate': string;
    'uploadDate': string;
    'campaignId'?: number | null;
    'scanState': RHIMCementServiceDataPointCloudScansScanState;
    'panoramaImagesState': RHIMCementServiceDataPointCloudScansPanoramaImagesState;
    'originalFilename': string;
    'referencePointOpening'?: RHIMCementServiceDataPointCloudScansPoint3D | null;
    'linkedScanInformation': RHIMCementServiceV1ModelsLinkedScanInformation;
    'latestExtraction'?: RHIMCementServiceV1ModelsExtractionOverviewDto | null;
    'publishedExtraction'?: RHIMCementServiceV1ModelsExtractionOverviewDto | null;
}


export interface RHIMCementServiceV1ModelsScanDownloadDto {
    'rawE57File': RHIMCementServiceV1ModelsDownloadFileState;
    'rawE57FileSize': number;
    'zippedPtsFile': RHIMCementServiceV1ModelsDownloadFileState;
    'zippedPtsFileSize': number;
    'zippedPanoramaImages': RHIMCementServiceV1ModelsDownloadFileState;
    'zippedPanoramaImagesFileSize': number;
    'numberOfPanoramaImages': number;
}


export interface RHIMCementServiceV1ModelsScanDto {
    'id': string;
    'vesselId': string;
    'scanDate': string;
    'uploadDate': string;
    'campaignId'?: number | null;
    'scanState': RHIMCementServiceDataPointCloudScansScanState;
    'initialProcessingErrorMessage'?: string | null;
    'initialProcessingLogOutput'?: string | null;
    'panoramaImagesState': RHIMCementServiceDataPointCloudScansPanoramaImagesState;
    'panoramaImagesProcessingErrorMessage'?: string | null;
    'panoramaImagesProcessingLogOutput'?: string | null;
    'refractoryCondition'?: RHIMCementServiceDataPointCloudScansRefractoryCondition | null;
    'scanResolution'?: RHIMCementServiceDataPointCloudScansScanResolution | null;
    'scanResponsible'?: string | null;
    'comment'?: string | null;
    'originalFilename': string;
    'referencePointOpening'?: RHIMCementServiceDataPointCloudScansPoint3D | null;
    'extractions': Array<RHIMCementServiceV1ModelsExtractionOverviewDto>;
    'linkedScanInformation': RHIMCementServiceV1ModelsLinkedScanInformation;
    'numberOfPanoramaImages': number;
}


export interface RHIMCementServiceV1ModelsScanOverviewDto {
    'id': string;
    'scanDate': string;
    'refractoryCondition'?: RHIMCementServiceDataPointCloudScansRefractoryCondition | null;
    'campaignId'?: number | null;
}


export interface RHIMCementServiceV1ModelsScanUpdateDto {
    'vesselId': string;
    'scanDate': string;
    'refractoryCondition'?: RHIMCementServiceDataPointCloudScansRefractoryCondition | null;
    'scanResolution'?: RHIMCementServiceDataPointCloudScansScanResolution | null;
    'scanResponsible'?: string | null;
    'comment'?: string | null;
    'referencePointOpening'?: RHIMCementServiceDataPointCloudScansPoint3D | null;
}


export interface RHIMCementServiceV1ModelsSliderRangeDto {
    'initial': number;
    'min': number;
    'max': number;
}
export interface RHIMCementServiceV1ModelsTriggerExtractionDto {
    'comment'?: string | null;
    'dustZones'?: Array<RHIMCementServiceV1ModelsDustZoneDto> | null;
}

export const RHIMContractsFileType = {
    PostMortem: 'PostMortem',
    ProcessData: 'ProcessData',
    ProcessMetrixFiltered: 'ProcessMetrixFiltered',
    ProcessMetrixRaw: 'ProcessMetrixRaw',
    ProcessMetrixVertex: 'ProcessMetrixVertex',
    ProcessMetrixSummary: 'ProcessMetrixSummary',
    ProcessMetrixZip: 'ProcessMetrixZip',
    Stl: 'STL',
    HarmonizedSummary: 'HarmonizedSummary',
    ProcessDataSplit: 'ProcessDataSplit',
    Pts: 'PTS',
    Clinker: 'Clinker',
    KilnFeed: 'KilnFeed',
    HotMeal: 'HotMeal',
    Lignite: 'Lignite',
    StopLogs: 'StopLogs',
    IrScan: 'IRScan',
    KilnShellCooling: 'KilnShellCooling',
    KilnProcessData: 'KilnProcessData',
    FerrotronSummary: 'FerrotronSummary',
} as const;

export type RHIMContractsFileType = typeof RHIMContractsFileType[keyof typeof RHIMContractsFileType];



export const RHIMContractsVesselType = {
    Bof: 'BOF',
    Rh: 'RH',
    Eaf: 'EAF',
    Ladle: 'Ladle',
    Crk: 'CRK',
    Rhl: 'RHL',
    Aod: 'AOD',
    Bfr: 'BFR',
    Srf: 'SRF',
    Cou: 'COU',
    Hml: 'HML',
} as const;

export type RHIMContractsVesselType = typeof RHIMContractsVesselType[keyof typeof RHIMContractsVesselType];



/**
 * CampaignApi - axios parameter creator
 */
export const CampaignApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a campaign
         * @summary Delete a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselsVesselidCampaignsCampaignnumber: async (vesselId: string, campaignNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('deleteVesselsVesselidCampaignsCampaignnumber', 'vesselId', vesselId)
            // verify required parameter 'campaignNumber' is not null or undefined
            assertParamExists('deleteVesselsVesselidCampaignsCampaignnumber', 'campaignNumber', campaignNumber)
            const localVarPath = `/vessels/{vesselId}/campaigns/{campaignNumber}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaignNumber}', encodeURIComponent(String(campaignNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of the configured campaigns for the specified vessel.
         * @summary Returns a list of the configured campaigns for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCampaigns: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCampaigns', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/campaigns`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a campaign by campaign number
         * @summary Retrieves a campaign by campaign number
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCampaignsCampaignnumber: async (vesselId: string, campaignNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidCampaignsCampaignnumber', 'vesselId', vesselId)
            // verify required parameter 'campaignNumber' is not null or undefined
            assertParamExists('getVesselsVesselidCampaignsCampaignnumber', 'campaignNumber', campaignNumber)
            const localVarPath = `/vessels/{vesselId}/campaigns/{campaignNumber}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaignNumber}', encodeURIComponent(String(campaignNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new campaign
         * @summary Create a new campaign
         * @param {string} vesselId Format - uuid. Identifier of the vessel
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidCampaigns: async (vesselId: string, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('postVesselsVesselidCampaigns', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/campaigns`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a campaign
         * @summary Update a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCampaignsCampaignnumber: async (vesselId: string, campaignNumber: number, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidCampaignsCampaignnumber', 'vesselId', vesselId)
            // verify required parameter 'campaignNumber' is not null or undefined
            assertParamExists('putVesselsVesselidCampaignsCampaignnumber', 'campaignNumber', campaignNumber)
            const localVarPath = `/vessels/{vesselId}/campaigns/{campaignNumber}`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)))
                .replace('{campaignNumber}', encodeURIComponent(String(campaignNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CampaignApi - functional programming interface
 */
export const CampaignApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CampaignApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a campaign
         * @summary Delete a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.deleteVesselsVesselidCampaignsCampaignnumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of the configured campaigns for the specified vessel.
         * @summary Returns a list of the configured campaigns for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsCampaignDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCampaigns(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getVesselsVesselidCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a campaign by campaign number
         * @summary Retrieves a campaign by campaign number
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.getVesselsVesselidCampaignsCampaignnumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new campaign
         * @summary Create a new campaign
         * @param {string} vesselId Format - uuid. Identifier of the vessel
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postVesselsVesselidCampaigns(vesselId: string, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postVesselsVesselidCampaigns(vesselId, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.postVesselsVesselidCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a campaign
         * @summary Update a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsCampaignDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CampaignApi.putVesselsVesselidCampaignsCampaignnumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CampaignApi - factory interface
 */
export const CampaignApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CampaignApiFp(configuration)
    return {
        /**
         * Delete a campaign
         * @summary Delete a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of the configured campaigns for the specified vessel.
         * @summary Returns a list of the configured campaigns for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsCampaignDto>> {
            return localVarFp.getVesselsVesselidCampaigns(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a campaign by campaign number
         * @summary Retrieves a campaign by campaign number
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsCampaignDto> {
            return localVarFp.getVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new campaign
         * @summary Create a new campaign
         * @param {string} vesselId Format - uuid. Identifier of the vessel
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postVesselsVesselidCampaigns(vesselId: string, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsCampaignDto> {
            return localVarFp.postVesselsVesselidCampaigns(vesselId, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a campaign
         * @summary Update a campaign
         * @param {string} vesselId Format - uuid.
         * @param {number} campaignNumber Format - int32.
         * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsCampaignDto> {
            return localVarFp.putVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CampaignApi - object-oriented interface
 */
export class CampaignApi extends BaseAPI {
    /**
     * Delete a campaign
     * @summary Delete a campaign
     * @param {string} vesselId Format - uuid.
     * @param {number} campaignNumber Format - int32.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).deleteVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of the configured campaigns for the specified vessel.
     * @summary Returns a list of the configured campaigns for the specified vessel.
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCampaigns(vesselId: string, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getVesselsVesselidCampaigns(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a campaign by campaign number
     * @summary Retrieves a campaign by campaign number
     * @param {string} vesselId Format - uuid.
     * @param {number} campaignNumber Format - int32.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).getVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new campaign
     * @summary Create a new campaign
     * @param {string} vesselId Format - uuid. Identifier of the vessel
     * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postVesselsVesselidCampaigns(vesselId: string, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).postVesselsVesselidCampaigns(vesselId, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a campaign
     * @summary Update a campaign
     * @param {string} vesselId Format - uuid.
     * @param {number} campaignNumber Format - int32.
     * @param {RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto} [rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidCampaignsCampaignnumber(vesselId: string, campaignNumber: number, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto?: RHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options?: RawAxiosRequestConfig) {
        return CampaignApiFp(this.configuration).putVesselsVesselidCampaignsCampaignnumber(vesselId, campaignNumber, rHIMCementServiceV1ModelsCreateOrUpdateCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExtractionApi - axios parameter creator
 */
export const ExtractionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the extraction with the given Id
         * @summary Deletes the extraction with the given Id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScansExtractionsExtractionid: async (extractionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractionId' is not null or undefined
            assertParamExists('deleteScansExtractionsExtractionid', 'extractionId', extractionId)
            const localVarPath = `/scans/extractions/{extractionId}`
                .replace('{extractionId}', encodeURIComponent(String(extractionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a scan extraction with the given id
         * @summary Returns a scan extraction with the given id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansExtractionsExtractionid: async (extractionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'extractionId' is not null or undefined
            assertParamExists('getScansExtractionsExtractionid', 'extractionId', extractionId)
            const localVarPath = `/scans/extractions/{extractionId}`
                .replace('{extractionId}', encodeURIComponent(String(extractionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Triggers the start of a new extraction
         * @summary Triggers the start of a new extraction
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsTriggerExtractionDto} [rHIMCementServiceV1ModelsTriggerExtractionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidExtraction: async (scanId: string, rHIMCementServiceV1ModelsTriggerExtractionDto?: RHIMCementServiceV1ModelsTriggerExtractionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('postScansScanidExtraction', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/extraction`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsTriggerExtractionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtractionApi - functional programming interface
 */
export const ExtractionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtractionApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the extraction with the given Id
         * @summary Deletes the extraction with the given Id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScansExtractionsExtractionid(extractionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractionApi.deleteScansExtractionsExtractionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a scan extraction with the given id
         * @summary Returns a scan extraction with the given id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsExtractionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansExtractionsExtractionid(extractionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractionApi.getScansExtractionsExtractionid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Triggers the start of a new extraction
         * @summary Triggers the start of a new extraction
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsTriggerExtractionDto} [rHIMCementServiceV1ModelsTriggerExtractionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postScansScanidExtraction(scanId: string, rHIMCementServiceV1ModelsTriggerExtractionDto?: RHIMCementServiceV1ModelsTriggerExtractionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsExtractionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postScansScanidExtraction(scanId, rHIMCementServiceV1ModelsTriggerExtractionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractionApi.postScansScanidExtraction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtractionApi - factory interface
 */
export const ExtractionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtractionApiFp(configuration)
    return {
        /**
         * Deletes the extraction with the given Id
         * @summary Deletes the extraction with the given Id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteScansExtractionsExtractionid(extractionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a scan extraction with the given id
         * @summary Returns a scan extraction with the given id
         * @param {string} extractionId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsExtractionDto> {
            return localVarFp.getScansExtractionsExtractionid(extractionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Triggers the start of a new extraction
         * @summary Triggers the start of a new extraction
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsTriggerExtractionDto} [rHIMCementServiceV1ModelsTriggerExtractionDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidExtraction(scanId: string, rHIMCementServiceV1ModelsTriggerExtractionDto?: RHIMCementServiceV1ModelsTriggerExtractionDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsExtractionDto> {
            return localVarFp.postScansScanidExtraction(scanId, rHIMCementServiceV1ModelsTriggerExtractionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExtractionApi - object-oriented interface
 */
export class ExtractionApi extends BaseAPI {
    /**
     * Deletes the extraction with the given Id
     * @summary Deletes the extraction with the given Id
     * @param {string} extractionId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig) {
        return ExtractionApiFp(this.configuration).deleteScansExtractionsExtractionid(extractionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a scan extraction with the given id
     * @summary Returns a scan extraction with the given id
     * @param {string} extractionId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansExtractionsExtractionid(extractionId: string, options?: RawAxiosRequestConfig) {
        return ExtractionApiFp(this.configuration).getScansExtractionsExtractionid(extractionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Triggers the start of a new extraction
     * @summary Triggers the start of a new extraction
     * @param {string} scanId Format - uuid.
     * @param {RHIMCementServiceV1ModelsTriggerExtractionDto} [rHIMCementServiceV1ModelsTriggerExtractionDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postScansScanidExtraction(scanId: string, rHIMCementServiceV1ModelsTriggerExtractionDto?: RHIMCementServiceV1ModelsTriggerExtractionDto, options?: RawAxiosRequestConfig) {
        return ExtractionApiFp(this.configuration).postScansScanidExtraction(scanId, rHIMCementServiceV1ModelsTriggerExtractionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KilnShellTemperatureProfilesApi - axios parameter creator
 */
export const KilnShellTemperatureProfilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no campaign is given the aggregation is done across all data available for the vessel
         * @summary Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no camp
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaign] Format - int32.
         * @param {string} [timestamp] Format - date-time (as date-time in RFC3339).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidKilnshelltemperatureprofiles: async (vesselId: string, campaign?: number, timestamp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidKilnshelltemperatureprofiles', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/kilnshelltemperatureprofiles`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaign !== undefined) {
                localVarQueryParameter['campaign'] = campaign;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KilnShellTemperatureProfilesApi - functional programming interface
 */
export const KilnShellTemperatureProfilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KilnShellTemperatureProfilesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no campaign is given the aggregation is done across all data available for the vessel
         * @summary Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no camp
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaign] Format - int32.
         * @param {string} [timestamp] Format - date-time (as date-time in RFC3339).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidKilnshelltemperatureprofiles(vesselId: string, campaign?: number, timestamp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsKilnShellTemperatureProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidKilnshelltemperatureprofiles(vesselId, campaign, timestamp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KilnShellTemperatureProfilesApi.getVesselsVesselidKilnshelltemperatureprofiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KilnShellTemperatureProfilesApi - factory interface
 */
export const KilnShellTemperatureProfilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KilnShellTemperatureProfilesApiFp(configuration)
    return {
        /**
         * Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no campaign is given the aggregation is done across all data available for the vessel
         * @summary Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no camp
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaign] Format - int32.
         * @param {string} [timestamp] Format - date-time (as date-time in RFC3339).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidKilnshelltemperatureprofiles(vesselId: string, campaign?: number, timestamp?: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsKilnShellTemperatureProfileDto> {
            return localVarFp.getVesselsVesselidKilnshelltemperatureprofiles(vesselId, campaign, timestamp, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KilnShellTemperatureProfilesApi - object-oriented interface
 */
export class KilnShellTemperatureProfilesApi extends BaseAPI {
    /**
     * Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no campaign is given the aggregation is done across all data available for the vessel
     * @summary Returns aggregated profile data of the kiln shell temperature for a given vessel.  If a timestamp is given it returns the aggregated profile data from the start of the campaign until that timestamp  If a campaign is given the aggregation is done across the whole campaign  If no timestamp and no camp
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {number} [campaign] Format - int32.
     * @param {string} [timestamp] Format - date-time (as date-time in RFC3339).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidKilnshelltemperatureprofiles(vesselId: string, campaign?: number, timestamp?: string, options?: RawAxiosRequestConfig) {
        return KilnShellTemperatureProfilesApiFp(this.configuration).getVesselsVesselidKilnshelltemperatureprofiles(vesselId, campaign, timestamp, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * KilnStoppagesApi - axios parameter creator
 */
export const KilnStoppagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all the stoppage events for the specified vessel.
         * @summary Returns a list of all the stoppage events for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidKilnstoppages: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidKilnstoppages', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/kilnstoppages`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KilnStoppagesApi - functional programming interface
 */
export const KilnStoppagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KilnStoppagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all the stoppage events for the specified vessel.
         * @summary Returns a list of all the stoppage events for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidKilnstoppages(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsKilnStoppageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidKilnstoppages(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KilnStoppagesApi.getVesselsVesselidKilnstoppages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KilnStoppagesApi - factory interface
 */
export const KilnStoppagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KilnStoppagesApiFp(configuration)
    return {
        /**
         * Returns a list of all the stoppage events for the specified vessel.
         * @summary Returns a list of all the stoppage events for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidKilnstoppages(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsKilnStoppageDto>> {
            return localVarFp.getVesselsVesselidKilnstoppages(vesselId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KilnStoppagesApi - object-oriented interface
 */
export class KilnStoppagesApi extends BaseAPI {
    /**
     * Returns a list of all the stoppage events for the specified vessel.
     * @summary Returns a list of all the stoppage events for the specified vessel.
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidKilnstoppages(vesselId: string, options?: RawAxiosRequestConfig) {
        return KilnStoppagesApiFp(this.configuration).getVesselsVesselidKilnstoppages(vesselId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PanoramaImagesApi - axios parameter creator
 */
export const PanoramaImagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @summary Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPanoramaImagesCoordinatesTxt: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidPanoramaImagesCoordinatesTxt', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/panorama_images/coordinates.txt`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the panorama images with the given id
         * @summary Returns the panorama images with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} panoramaImageId Format - uuid.
         * @param {string} [quality] Optional query parameter that defines the quality of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPanoramaImagesImagesPanoramaimageid: async (scanId: string, panoramaImageId: string, quality?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidPanoramaImagesImagesPanoramaimageid', 'scanId', scanId)
            // verify required parameter 'panoramaImageId' is not null or undefined
            assertParamExists('getScansScanidPanoramaImagesImagesPanoramaimageid', 'panoramaImageId', panoramaImageId)
            const localVarPath = `/scans/{scanId}/panorama_images/images/{panoramaImageId}`
                .replace('{scanId}', encodeURIComponent(String(scanId)))
                .replace('{panoramaImageId}', encodeURIComponent(String(panoramaImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (quality !== undefined) {
                localVarQueryParameter['quality'] = quality;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PanoramaImagesApi - functional programming interface
 */
export const PanoramaImagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PanoramaImagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @summary Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidPanoramaImagesCoordinatesTxt(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidPanoramaImagesCoordinatesTxt(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanoramaImagesApi.getScansScanidPanoramaImagesCoordinatesTxt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the panorama images with the given id
         * @summary Returns the panorama images with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} panoramaImageId Format - uuid.
         * @param {string} [quality] Optional query parameter that defines the quality of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidPanoramaImagesImagesPanoramaimageid(scanId: string, panoramaImageId: string, quality?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidPanoramaImagesImagesPanoramaimageid(scanId, panoramaImageId, quality, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanoramaImagesApi.getScansScanidPanoramaImagesImagesPanoramaimageid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PanoramaImagesApi - factory interface
 */
export const PanoramaImagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PanoramaImagesApiFp(configuration)
    return {
        /**
         * Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @summary Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPanoramaImagesCoordinatesTxt(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidPanoramaImagesCoordinatesTxt(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the panorama images with the given id
         * @summary Returns the panorama images with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} panoramaImageId Format - uuid.
         * @param {string} [quality] Optional query parameter that defines the quality of the image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPanoramaImagesImagesPanoramaimageid(scanId: string, panoramaImageId: string, quality?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidPanoramaImagesImagesPanoramaimageid(scanId, panoramaImageId, quality, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PanoramaImagesApi - object-oriented interface
 */
export class PanoramaImagesApi extends BaseAPI {
    /**
     * Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
     * @summary Returns a csv file with the coordinates of the panorama images of the scan with the given id  The coordinates need to be in this weird csv format as we use potree (https://github.com/potree/potree) in the frontend and it requires this csv file
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidPanoramaImagesCoordinatesTxt(scanId: string, options?: RawAxiosRequestConfig) {
        return PanoramaImagesApiFp(this.configuration).getScansScanidPanoramaImagesCoordinatesTxt(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the panorama images with the given id
     * @summary Returns the panorama images with the given id
     * @param {string} scanId Format - uuid.
     * @param {string} panoramaImageId Format - uuid.
     * @param {string} [quality] Optional query parameter that defines the quality of the image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidPanoramaImagesImagesPanoramaimageid(scanId: string, panoramaImageId: string, quality?: string, options?: RawAxiosRequestConfig) {
        return PanoramaImagesApiFp(this.configuration).getScansScanidPanoramaImagesImagesPanoramaimageid(scanId, panoramaImageId, quality, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessDataApi - axios parameter creator
 */
export const ProcessDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all the process data for the specified vessel.
         * @summary Returns a list of all the process data for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidProcessdata: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidProcessdata', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/processdata`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessDataApi - functional programming interface
 */
export const ProcessDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all the process data for the specified vessel.
         * @summary Returns a list of all the process data for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidProcessdata(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsProcessDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidProcessdata(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDataApi.getVesselsVesselidProcessdata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessDataApi - factory interface
 */
export const ProcessDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessDataApiFp(configuration)
    return {
        /**
         * Returns a list of all the process data for the specified vessel.
         * @summary Returns a list of all the process data for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidProcessdata(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsProcessDataDto>> {
            return localVarFp.getVesselsVesselidProcessdata(vesselId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcessDataApi - object-oriented interface
 */
export class ProcessDataApi extends BaseAPI {
    /**
     * Returns a list of all the process data for the specified vessel.
     * @summary Returns a list of all the process data for the specified vessel.
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidProcessdata(vesselId: string, options?: RawAxiosRequestConfig) {
        return ProcessDataApiFp(this.configuration).getVesselsVesselidProcessdata(vesselId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QualityDataApi - axios parameter creator
 */
export const QualityDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a list of all the quality data for the specified vessel grouped by the process step
         * @summary Returns a list of all the quality data for the specified vessel grouped by the process step
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidQualitydata: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidQualitydata', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/qualitydata`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QualityDataApi - functional programming interface
 */
export const QualityDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QualityDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a list of all the quality data for the specified vessel grouped by the process step
         * @summary Returns a list of all the quality data for the specified vessel grouped by the process step
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidQualitydata(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsQualityDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidQualitydata(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QualityDataApi.getVesselsVesselidQualitydata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QualityDataApi - factory interface
 */
export const QualityDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QualityDataApiFp(configuration)
    return {
        /**
         * Returns a list of all the quality data for the specified vessel grouped by the process step
         * @summary Returns a list of all the quality data for the specified vessel grouped by the process step
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidQualitydata(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsQualityDataDto>> {
            return localVarFp.getVesselsVesselidQualitydata(vesselId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QualityDataApi - object-oriented interface
 */
export class QualityDataApi extends BaseAPI {
    /**
     * Returns a list of all the quality data for the specified vessel grouped by the process step
     * @summary Returns a list of all the quality data for the specified vessel grouped by the process step
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidQualitydata(vesselId: string, options?: RawAxiosRequestConfig) {
        return QualityDataApiFp(this.configuration).getVesselsVesselidQualitydata(vesselId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportConfigApi - axios parameter creator
 */
export const ReportConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @summary Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidReportconfig: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidReportconfig', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/reportconfig`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update / Set the LES report config of a vessel
         * @summary Update / Set the LES report config of a vessel
         * @param {string} vesselId Format - uuid.
         * @param {RHIMCementServiceV1ModelsReportConfigDto} [rHIMCementServiceV1ModelsReportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidReportconfig: async (vesselId: string, rHIMCementServiceV1ModelsReportConfigDto?: RHIMCementServiceV1ModelsReportConfigDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('putVesselsVesselidReportconfig', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/reportconfig`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsReportConfigDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportConfigApi - functional programming interface
 */
export const ReportConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @summary Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidReportconfig(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsReportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidReportconfig(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigApi.getVesselsVesselidReportconfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update / Set the LES report config of a vessel
         * @summary Update / Set the LES report config of a vessel
         * @param {string} vesselId Format - uuid.
         * @param {RHIMCementServiceV1ModelsReportConfigDto} [rHIMCementServiceV1ModelsReportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putVesselsVesselidReportconfig(vesselId: string, rHIMCementServiceV1ModelsReportConfigDto?: RHIMCementServiceV1ModelsReportConfigDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsReportConfigDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putVesselsVesselidReportconfig(vesselId, rHIMCementServiceV1ModelsReportConfigDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigApi.putVesselsVesselidReportconfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportConfigApi - factory interface
 */
export const ReportConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportConfigApiFp(configuration)
    return {
        /**
         * Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @summary Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidReportconfig(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsReportConfigDto> {
            return localVarFp.getVesselsVesselidReportconfig(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update / Set the LES report config of a vessel
         * @summary Update / Set the LES report config of a vessel
         * @param {string} vesselId Format - uuid.
         * @param {RHIMCementServiceV1ModelsReportConfigDto} [rHIMCementServiceV1ModelsReportConfigDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putVesselsVesselidReportconfig(vesselId: string, rHIMCementServiceV1ModelsReportConfigDto?: RHIMCementServiceV1ModelsReportConfigDto, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsReportConfigDto> {
            return localVarFp.putVesselsVesselidReportconfig(vesselId, rHIMCementServiceV1ModelsReportConfigDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportConfigApi - object-oriented interface
 */
export class ReportConfigApi extends BaseAPI {
    /**
     * Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
     * @summary Returns the report configuration, if none is configured a default configuration is returned.  The report configuration is saved per user, the UserId is taken from the Header X-RHIM-ApoId
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidReportconfig(vesselId: string, options?: RawAxiosRequestConfig) {
        return ReportConfigApiFp(this.configuration).getVesselsVesselidReportconfig(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update / Set the LES report config of a vessel
     * @summary Update / Set the LES report config of a vessel
     * @param {string} vesselId Format - uuid.
     * @param {RHIMCementServiceV1ModelsReportConfigDto} [rHIMCementServiceV1ModelsReportConfigDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putVesselsVesselidReportconfig(vesselId: string, rHIMCementServiceV1ModelsReportConfigDto?: RHIMCementServiceV1ModelsReportConfigDto, options?: RawAxiosRequestConfig) {
        return ReportConfigApiFp(this.configuration).putVesselsVesselidReportconfig(vesselId, rHIMCementServiceV1ModelsReportConfigDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScanApi - axios parameter creator
 */
export const ScanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes the scan with the given Id
         * @summary Deletes the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScansScanid: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('deleteScansScanid', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a scan with the given id
         * @summary Returns a scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanid: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanid', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the  file with the given name of the potree folder of the scan with the given id
         * @summary Returns the  file with the given name of the potree folder of the scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPotreeFilename: async (scanId: string, filename: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidPotreeFilename', 'scanId', scanId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('getScansScanidPotreeFilename', 'filename', filename)
            const localVarPath = `/scans/{scanId}/potree/{filename}`
                .replace('{scanId}', encodeURIComponent(String(scanId)))
                .replace('{filename}', encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of the scans for the specified vessel.
         * @summary Returns a list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaignNumber] Format - int32. Optional query parameter to filter the scans by campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidScans: async (vesselId: string, campaignNumber?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidScans', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/scans`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (campaignNumber !== undefined) {
                localVarQueryParameter['campaignNumber'] = campaignNumber;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a more detailed list of the scans for the specified vessel.
         * @summary Returns a more detailed list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidScansDetailed: async (vesselId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vesselId' is not null or undefined
            assertParamExists('getVesselsVesselidScansDetailed', 'vesselId', vesselId)
            const localVarPath = `/vessels/{vesselId}/scans/detailed`
                .replace('{vesselId}', encodeURIComponent(String(vesselId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unpublish all extractions and then published one extraction (if any is provided)
         * @summary Unpublish all extractions and then published one extraction (if any is provided)
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsPublishExtractioDto} [rHIMCementServiceV1ModelsPublishExtractioDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidPublish: async (scanId: string, rHIMCementServiceV1ModelsPublishExtractioDto?: RHIMCementServiceV1ModelsPublishExtractioDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('postScansScanidPublish', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/publish`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsPublishExtractioDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the scan with the given Id
         * @summary Updates the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsScanUpdateDto} [rHIMCementServiceV1ModelsScanUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putScansScanid: async (scanId: string, rHIMCementServiceV1ModelsScanUpdateDto?: RHIMCementServiceV1ModelsScanUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('putScansScanid', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rHIMCementServiceV1ModelsScanUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScanApi - functional programming interface
 */
export const ScanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScanApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes the scan with the given Id
         * @summary Deletes the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteScansScanid(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteScansScanid(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.deleteScansScanid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a scan with the given id
         * @summary Returns a scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanid(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsScanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanid(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.getScansScanid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the  file with the given name of the potree folder of the scan with the given id
         * @summary Returns the  file with the given name of the potree folder of the scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidPotreeFilename(scanId: string, filename: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidPotreeFilename(scanId, filename, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.getScansScanidPotreeFilename']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of the scans for the specified vessel.
         * @summary Returns a list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaignNumber] Format - int32. Optional query parameter to filter the scans by campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidScans(vesselId: string, campaignNumber?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsScanOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidScans(vesselId, campaignNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.getVesselsVesselidScans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a more detailed list of the scans for the specified vessel.
         * @summary Returns a more detailed list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVesselsVesselidScansDetailed(vesselId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RHIMCementServiceV1ModelsScanDetailedOverviewDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVesselsVesselidScansDetailed(vesselId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.getVesselsVesselidScansDetailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unpublish all extractions and then published one extraction (if any is provided)
         * @summary Unpublish all extractions and then published one extraction (if any is provided)
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsPublishExtractioDto} [rHIMCementServiceV1ModelsPublishExtractioDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postScansScanidPublish(scanId: string, rHIMCementServiceV1ModelsPublishExtractioDto?: RHIMCementServiceV1ModelsPublishExtractioDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postScansScanidPublish(scanId, rHIMCementServiceV1ModelsPublishExtractioDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.postScansScanidPublish']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the scan with the given Id
         * @summary Updates the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsScanUpdateDto} [rHIMCementServiceV1ModelsScanUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putScansScanid(scanId: string, rHIMCementServiceV1ModelsScanUpdateDto?: RHIMCementServiceV1ModelsScanUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putScansScanid(scanId, rHIMCementServiceV1ModelsScanUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanApi.putScansScanid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScanApi - factory interface
 */
export const ScanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScanApiFp(configuration)
    return {
        /**
         * Deletes the scan with the given Id
         * @summary Deletes the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteScansScanid(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteScansScanid(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a scan with the given id
         * @summary Returns a scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanid(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsScanDto> {
            return localVarFp.getScansScanid(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the  file with the given name of the potree folder of the scan with the given id
         * @summary Returns the  file with the given name of the potree folder of the scan with the given id
         * @param {string} scanId Format - uuid.
         * @param {string} filename 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidPotreeFilename(scanId: string, filename: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidPotreeFilename(scanId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of the scans for the specified vessel.
         * @summary Returns a list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {number} [campaignNumber] Format - int32. Optional query parameter to filter the scans by campaign
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidScans(vesselId: string, campaignNumber?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsScanOverviewDto>> {
            return localVarFp.getVesselsVesselidScans(vesselId, campaignNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a more detailed list of the scans for the specified vessel.
         * @summary Returns a more detailed list of the scans for the specified vessel.
         * @param {string} vesselId Format - uuid. The Id of the vessel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVesselsVesselidScansDetailed(vesselId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RHIMCementServiceV1ModelsScanDetailedOverviewDto>> {
            return localVarFp.getVesselsVesselidScansDetailed(vesselId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unpublish all extractions and then published one extraction (if any is provided)
         * @summary Unpublish all extractions and then published one extraction (if any is provided)
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsPublishExtractioDto} [rHIMCementServiceV1ModelsPublishExtractioDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidPublish(scanId: string, rHIMCementServiceV1ModelsPublishExtractioDto?: RHIMCementServiceV1ModelsPublishExtractioDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postScansScanidPublish(scanId, rHIMCementServiceV1ModelsPublishExtractioDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the scan with the given Id
         * @summary Updates the scan with the given Id
         * @param {string} scanId Format - uuid.
         * @param {RHIMCementServiceV1ModelsScanUpdateDto} [rHIMCementServiceV1ModelsScanUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putScansScanid(scanId: string, rHIMCementServiceV1ModelsScanUpdateDto?: RHIMCementServiceV1ModelsScanUpdateDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.putScansScanid(scanId, rHIMCementServiceV1ModelsScanUpdateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScanApi - object-oriented interface
 */
export class ScanApi extends BaseAPI {
    /**
     * Deletes the scan with the given Id
     * @summary Deletes the scan with the given Id
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteScansScanid(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).deleteScansScanid(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a scan with the given id
     * @summary Returns a scan with the given id
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanid(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).getScansScanid(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the  file with the given name of the potree folder of the scan with the given id
     * @summary Returns the  file with the given name of the potree folder of the scan with the given id
     * @param {string} scanId Format - uuid.
     * @param {string} filename 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidPotreeFilename(scanId: string, filename: string, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).getScansScanidPotreeFilename(scanId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of the scans for the specified vessel.
     * @summary Returns a list of the scans for the specified vessel.
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {number} [campaignNumber] Format - int32. Optional query parameter to filter the scans by campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidScans(vesselId: string, campaignNumber?: number, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).getVesselsVesselidScans(vesselId, campaignNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a more detailed list of the scans for the specified vessel.
     * @summary Returns a more detailed list of the scans for the specified vessel.
     * @param {string} vesselId Format - uuid. The Id of the vessel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getVesselsVesselidScansDetailed(vesselId: string, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).getVesselsVesselidScansDetailed(vesselId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unpublish all extractions and then published one extraction (if any is provided)
     * @summary Unpublish all extractions and then published one extraction (if any is provided)
     * @param {string} scanId Format - uuid.
     * @param {RHIMCementServiceV1ModelsPublishExtractioDto} [rHIMCementServiceV1ModelsPublishExtractioDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postScansScanidPublish(scanId: string, rHIMCementServiceV1ModelsPublishExtractioDto?: RHIMCementServiceV1ModelsPublishExtractioDto, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).postScansScanidPublish(scanId, rHIMCementServiceV1ModelsPublishExtractioDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the scan with the given Id
     * @summary Updates the scan with the given Id
     * @param {string} scanId Format - uuid.
     * @param {RHIMCementServiceV1ModelsScanUpdateDto} [rHIMCementServiceV1ModelsScanUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putScansScanid(scanId: string, rHIMCementServiceV1ModelsScanUpdateDto?: RHIMCementServiceV1ModelsScanUpdateDto, options?: RawAxiosRequestConfig) {
        return ScanApiFp(this.configuration).putScansScanid(scanId, rHIMCementServiceV1ModelsScanUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScanDownloadApi - axios parameter creator
 */
export const ScanDownloadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns information about the available downloads of the scan
         * @summary Returns information about the available downloads of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownload: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidDownload', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the e57 file of the scan
         * @summary Download the e57 file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadE57: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidDownloadE57', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download/e57`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the zipped pts file of all the panorama images
         * @summary Download the zipped pts file of all the panorama images
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadPanoramaimageszip: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidDownloadPanoramaimageszip', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download/panoramaimageszip`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download the zipped pts file of the scan
         * @summary Download the zipped pts file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadPtszip: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('getScansScanidDownloadPtszip', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download/ptszip`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate a zip file with all panorama images of the scan for later downloading
         * @summary Generate a zip file with all panorama images of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidDownloadGeneratePanoramaimageszip: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('postScansScanidDownloadGeneratePanoramaimageszip', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download/generate/panoramaimageszip`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate the zipped pts file of the scan for later downloading
         * @summary Generate the zipped pts file of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidDownloadGeneratePtszip: async (scanId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scanId' is not null or undefined
            assertParamExists('postScansScanidDownloadGeneratePtszip', 'scanId', scanId)
            const localVarPath = `/scans/{scanId}/download/generate/ptszip`
                .replace('{scanId}', encodeURIComponent(String(scanId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScanDownloadApi - functional programming interface
 */
export const ScanDownloadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScanDownloadApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns information about the available downloads of the scan
         * @summary Returns information about the available downloads of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidDownload(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RHIMCementServiceV1ModelsScanDownloadDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidDownload(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.getScansScanidDownload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download the e57 file of the scan
         * @summary Download the e57 file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidDownloadE57(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidDownloadE57(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.getScansScanidDownloadE57']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download the zipped pts file of all the panorama images
         * @summary Download the zipped pts file of all the panorama images
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidDownloadPanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidDownloadPanoramaimageszip(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.getScansScanidDownloadPanoramaimageszip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download the zipped pts file of the scan
         * @summary Download the zipped pts file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScansScanidDownloadPtszip(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScansScanidDownloadPtszip(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.getScansScanidDownloadPtszip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate a zip file with all panorama images of the scan for later downloading
         * @summary Generate a zip file with all panorama images of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postScansScanidDownloadGeneratePanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postScansScanidDownloadGeneratePanoramaimageszip(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.postScansScanidDownloadGeneratePanoramaimageszip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate the zipped pts file of the scan for later downloading
         * @summary Generate the zipped pts file of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postScansScanidDownloadGeneratePtszip(scanId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postScansScanidDownloadGeneratePtszip(scanId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScanDownloadApi.postScansScanidDownloadGeneratePtszip']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScanDownloadApi - factory interface
 */
export const ScanDownloadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScanDownloadApiFp(configuration)
    return {
        /**
         * Returns information about the available downloads of the scan
         * @summary Returns information about the available downloads of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownload(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<RHIMCementServiceV1ModelsScanDownloadDto> {
            return localVarFp.getScansScanidDownload(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the e57 file of the scan
         * @summary Download the e57 file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadE57(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidDownloadE57(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the zipped pts file of all the panorama images
         * @summary Download the zipped pts file of all the panorama images
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadPanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidDownloadPanoramaimageszip(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download the zipped pts file of the scan
         * @summary Download the zipped pts file of the scan
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScansScanidDownloadPtszip(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getScansScanidDownloadPtszip(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate a zip file with all panorama images of the scan for later downloading
         * @summary Generate a zip file with all panorama images of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidDownloadGeneratePanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postScansScanidDownloadGeneratePanoramaimageszip(scanId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate the zipped pts file of the scan for later downloading
         * @summary Generate the zipped pts file of the scan for later downloading
         * @param {string} scanId Format - uuid.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postScansScanidDownloadGeneratePtszip(scanId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postScansScanidDownloadGeneratePtszip(scanId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScanDownloadApi - object-oriented interface
 */
export class ScanDownloadApi extends BaseAPI {
    /**
     * Returns information about the available downloads of the scan
     * @summary Returns information about the available downloads of the scan
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidDownload(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).getScansScanidDownload(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the e57 file of the scan
     * @summary Download the e57 file of the scan
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidDownloadE57(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).getScansScanidDownloadE57(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the zipped pts file of all the panorama images
     * @summary Download the zipped pts file of all the panorama images
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidDownloadPanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).getScansScanidDownloadPanoramaimageszip(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download the zipped pts file of the scan
     * @summary Download the zipped pts file of the scan
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getScansScanidDownloadPtszip(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).getScansScanidDownloadPtszip(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate a zip file with all panorama images of the scan for later downloading
     * @summary Generate a zip file with all panorama images of the scan for later downloading
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postScansScanidDownloadGeneratePanoramaimageszip(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).postScansScanidDownloadGeneratePanoramaimageszip(scanId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate the zipped pts file of the scan for later downloading
     * @summary Generate the zipped pts file of the scan for later downloading
     * @param {string} scanId Format - uuid.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postScansScanidDownloadGeneratePtszip(scanId: string, options?: RawAxiosRequestConfig) {
        return ScanDownloadApiFp(this.configuration).postScansScanidDownloadGeneratePtszip(scanId, options).then((request) => request(this.axios, this.basePath));
    }
}



